import React,{useContext,useEffect, useState,useRef,useCallback,useMemo} from 'react';
import { getRequest, postRequest, putRequest,deleteRequest, tabulatorGet } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon} from "../../svg/svgIcons";
import {useReactToPrint} from "react-to-print";
import { InfinitySpin } from  'react-loader-spinner';
import { DateTime } from "luxon";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { cleanSorters, parseSorters, parseMaskFilters, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart } from '../../../utils/tabulatorProgressiveLoading';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { Avatar } from 'primereact/avatar';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';
const SUMMARY_EMAIL_TRAINING_LIST_COLUMN_I18N_KEYS = Object.freeze({
  'name': 'Common.Name',
  'status': 'Common.Type',
  'regularity': 'Common.Frequency',
  'custom_regularity': 'SummaryEmailOTKList.Column.RegularityDetail',
  'email_time': 'SummaryEmailOTKList.Column.EmailTime',
  'custom_other_emails': 'SummaryEmailOTKList.Column.OtherEmails',
  'id': 'Common.Name',
  'interval': 'SummaryEmailOTKList.Column.Interval',
  'custom_employees': 'SummaryEmailOTKList.Column.Employees',
});


export default function SummaryEmailTrainingList(){

  const [state,dispatch] = useContext(DatabaseContext);
  const {user} = useContext(AuthContext);
  const { t, locale } = useContext(LocaleContext);
  const {openFavoriteDialog,toast,setFastView,setUserMaskFilter,setDialogText,setVisible, openChosenNotificationPreferences} = useContext(UtilContext);

    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes("edit training-setup"));

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [expandedKeys, setExpandedKeys] = useState({});


    const [searchIconColor,setSearchIconColor] = useState("");

    const [markUnmark, setMarkUnmarked] = useState(true);

    const [columnsVisible, setColumnsVisible] = useState({name: true,status: true,interval: true,regularity:true,custom_regularity:true,email_time:true,
    custom_employees:true,custom_other_emails:true
    });
    const [maskVisible, setMaskVisible] = useState(false);
const ref = useRef(null);
    const elementRef = useRef(null);
    const componentRef = useRef(null);
    const overlayRef = useRef(null);
    const tableBuiltRef = useRef(false);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const userInteractedRef = useRef(false);
    const isRestoringRef = useRef(false);

    const captureHScroll = () => {
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    };
    const restoreHScroll = () => {
      if (!savedHScrollRef.current.pending) return;
      const table = getTable();
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    };

    const pageSizePc = useMemo(() => {
      const v = (state.module_settings || []).find(s => s.module === 'global' && s.key === 'page_size_pc')?.value;
      const n = parseInt(v, 10);
      return (Number.isFinite(n) && n > 0) ? n : 50;
    }, [state.module_settings]);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingEllipsis')), [getTable]);
    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
      const extra = { type: 'training', ...extractSafePaginationParams(paramsFromTabulator) };
      if (extra.size == null) extra.size = pageSizePc;
      const table = getTable();
      const tableReadyForParams = tableBuiltRef.current;
      let hf = [];
      if (tableReadyForParams) hf = table?.getHeaderFilters?.() ?? [];
      if (tableReadyForParams && hf.length) {
        hf.forEach(f => {
          if (f?.field == null) return;
          const v = f.value;
          if (v === undefined || v === null || typeof v === 'object') return;
          const str = String(v).trim();
          if (str === '') return;
          extra[`filter_${f.field}`] = str;
        });
      } else if (!tableReadyForParams && state.user_mask_filters) {
        const maskRow = state.user_mask_filters.find(m => m.page === 'SummaryEmailTrainingList');
        if (maskRow) parseMaskFilters(maskRow.filters).forEach(f => {
          if (!f?.field) return;
          const v = f.value;
          if (v === undefined || v === null || String(v).trim() === '') return;
          extra[`filter_${f.field}`] = v;
        });
      }
      let sortersFromTable = [];
      if (tableReadyForParams) sortersFromTable = table?.getSorters?.() ?? [];
      if (Array.isArray(sortersFromTable) && sortersFromTable.length > 0) {
        const clean = cleanSorters(sortersFromTable);
        if (clean.length > 0) extra.sorters = JSON.stringify(clean);
      } else if (!tableReadyForParams && state.user_mask_filters) {
        const maskRow = state.user_mask_filters.find(m => m.page === 'SummaryEmailTrainingList');
        if (maskRow?.sorters) {
          const parsed = parseSorters(maskRow.sorters);
          if (parsed.length > 0) extra.sorters = JSON.stringify(parsed.map(s => ({ field: s.field ?? s.column, dir: s.dir })));
        }
      }
      return extra;
    }, [getTable, state.user_mask_filters, pageSizePc]);

  function matchAny(data, filterParams) {
    //data - the data for the row being filtered
    //filterParams - params object passed to the filter
    //RegExp - modifier "i" - case insensitve

    var match = false;
    const regex = RegExp(filterParams.value, 'i');

    for (var key in data) {
        if (regex.test(data[key]) === true) {
            match = true;
        }
    }
    return match;
  }


    const accept = () => {
        const rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          deleteRequest(`/api/summary_emails/${element.id}`)
              .then(() => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                refreshFromStart();
              })
              .catch(() => toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 }));
        });
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('Common.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

  const rowClick = (e, row) => {
    console.log(e, row);
 };

  const onSelectRow = (data, rows) => {
    setEditIcon(true);
    setCopyIcon(true);
    setDeleteIcon(true);
    if(ref.current.getSelectedData().length>0){
      if(ref.current.getSelectedData().length == 1){
        if(user.permissions?.includes("edit training-setup"))setCopyIcon(false);
        if(user.permissions?.includes("edit training-setup"))setEditIcon(false);
      }
      if(user.permissions?.includes("delete training-setup"))setDeleteIcon(false);
    }
  };

  function onEditRow(summary_email){
    dispatch({type: 'create_new_tab', name: t('Common.SummaryEmail'), translationKey: 'Common.SummaryEmail', legacyLabel: t('Common.SummaryEmail'),page:'SummaryEmailTrainingAdd',props:{summary_email: summary_email,type:'edit',not_last_used: true},mask:'trng032'})
  };
  
  function EditRowFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
  }

  function TimeFormatter(props){
    const rowData = props.cell.getRow().getData();
    const parsed = parseSummaryData(rowData?.data);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed.join('/');
    }
    return null;
  }

  function RegularityFormatter(props){
    const rowData = props.cell.getRow().getData();
    const parsed = parseSummaryData(rowData?.data);
    const period = Array.isArray(parsed?.time_period) ? parsed.time_period : [];
    if (period.length > 0) {
      return period.map((item) => item?.name).filter(Boolean).join('/');
    }
    return null;
  }

  function parseSummaryData(rawData){
    if (!rawData) return {};
    if (typeof rawData === 'object') return rawData;
    if (typeof rawData !== 'string') return {};
    try {
      return JSON.parse(rawData);
    } catch (_e) {
      return {};
    }
  }

  function OtherEmailsFormatter(props){
    const rowData = props.cell.getRow().getData();
    if(rowData.other_emails){
      return rowData.other_emails.split(',').join('/');
    }
    else{
      return null;
    }
  }

  function EmployeesFormatter(props) {
    const rowData = props.cell.getRow().getData();
    let initials="";
    return rowData.employees.map((item) => {
      const allNames = item.name.trim().split(' ');
      if(allNames.length == 3){
        initials = allNames.reduce((acc, curr, index) => {
          if(index === allNames.length - 2 || index === allNames.length - 1){
            acc = `${acc}${curr.charAt(0).toUpperCase()}`;
          }
          return acc;
        }, '');
      }
      else{
        initials = allNames.reduce((acc, curr, index) => {
          if(index === 0 || index === allNames.length - 1){
            acc = `${acc}${curr.charAt(0).toUpperCase()}`;
          }
          return acc;
        }, '');
      }
      return <Avatar title={item.name} label={initials} shape="circle" style={{ backgroundColor: '#1d4ed8', color: '#ffffff',marginRight: '5px'}} />;
    });
  }

  function employeesHeaderFilter(headerValue, rowValue, rowData, filterParams){
    let employees = rowData.employees.map(item => item.name);
    for(let i = 0;i<employees.length;i++){
      let filter = headerValue.toLowerCase();
      let value = employees[i].toLowerCase();
      if(value.includes(filter)){
        return true;
      }
    }
    return false;
  }

  const columns = [
    { title: '', field: 'id', formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, minWidth: 44, headerSort: false, resizable: false },
    { title: '', field: 'editor', hozAlign:"center", width: 44, minWidth: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false },
    { title: t('Common.Name'), field: 'name',headerFilter:"input",minWidth: 200,resizable:false },
    { title: t('Common.Type'), field: 'status',headerFilter:"input",minWidth: 200,resizable:false },
    { title: t('SummaryEmailOTKList.Column.Interval'), field: 'interval',headerFilter:"input",minWidth: 200,resizable:false },
    { title: t('Common.Frequency'), field: 'regularity', headerFilter: 'input', width: 220, minWidth: 220, resizable: false },
    { title: t('SummaryEmailOTKList.Column.RegularityDetail'), field: 'custom_regularity', headerFilter: 'input', width: 240, minWidth: 240, resizable: false, formatter: reactFormatter(<RegularityFormatter/>) },
    { title: t('SummaryEmailOTKList.Column.EmailTime'), field: 'email_time', headerFilter: 'input', width: 240, minWidth: 240, resizable: false },
    { title: t('SummaryEmailOTKList.Column.Employees'), field: 'custom_employees',headerFilter:"input",headerFilterFunc:employeesHeaderFilter,minWidth: 200,formatter: reactFormatter(<EmployeesFormatter/>),resizable:false },
    { title: t('SummaryEmailOTKList.Column.OtherEmails'), field: 'custom_other_emails',headerFilter:"input",minWidth: 200,resizable:false, formatter: reactFormatter(<OtherEmailsFormatter/>) },
  ];

  const scrollToFirst = () => scrollToFirstUtil(getTable());
  const scrollUp = () => scrollUpUtil(getTable());
  const scrollDown = () => scrollDownUtil(getTable());
  const scrollToLast = () => scrollToLastUtil(getTable());
  
  function addNewSummaryEmail(){
    dispatch({type: 'create_new_tab', name: t('Common.SummaryEmail'), translationKey: 'Common.SummaryEmail', legacyLabel: t('Common.SummaryEmail'),page:'SummaryEmailTrainingAdd',props:{summary_email: null,type:'add'},mask:'trng032'})
  }
  function copySummaryEmail(){
    dispatch({type: 'create_new_tab', name: t('Common.SummaryEmail'), translationKey: 'Common.SummaryEmail', legacyLabel: t('Common.SummaryEmail'),page:'SummaryEmailTrainingAdd',props:{summary_email: ref.current.getSelectedData()[0],type:'add',not_last_used: true},mask:'trng032'})
  }
  function editSummaryEmail(){
    dispatch({type: 'create_new_tab', name: t('Common.SummaryEmail'), translationKey: 'Common.SummaryEmail', legacyLabel: t('Common.SummaryEmail'),page:'SummaryEmailTrainingAdd',props:{summary_email: ref.current.getSelectedData()[0],type:'edit',not_last_used: true},mask:'trng032'})
  }

  function searchTable(){
    setSearchIconColor("active");
    ref.current.addFilter(matchAny, { value: searchValue});
    if (searchValue === "") {
      setSearchIconColor("");
      ref.current.removeFilter();
    }
    setVisibleSearch(false);
  }

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const defaultColumnsVisibleSummaryEmailTraining = { name: true, status: true, interval: true, regularity: true, custom_regularity: true, email_time: true, custom_employees: true, custom_other_emails: true };
  const resetMask = () => resetTabulatorMask({ page: 'SummaryEmailTrainingList', defaultColumnsVisible: defaultColumnsVisibleSummaryEmailTraining, ref, columns, setColumnsVisible });

  const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => {setUserMaskFilter("SummaryEmailTrainingList","set_filters",null,ref.current.getHeaderFilters(),null);},
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => {setUserMaskFilter("SummaryEmailTrainingList","set_filters",null,[],null);ref.current.clearHeaderFilter();},
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('Common.SetSorting'),
              icon: 'pi pi-sort-alt',
              command: () => {setUserMaskFilter("SummaryEmailTrainingList","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => {setUserMaskFilter("SummaryEmailTrainingList","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
          },
          {
            key: '0_6',
            label: t('Common.Notifications'),
            icon: 'pi pi-envelope',
            command: () => {openChosenNotificationPreferences('SummaryEmailTrainingList');OverflowMenuProvider.setVisible(null);},
            template: itemRenderer,
        },
      ]
    }
  ];function changeMarkings(value){
    const columnVisible = {...columnsVisible};
      for(let val in columnVisible) {
        if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
          columnVisible[val]=value;
          ref.current.showColumn(`${val}`);
        }
      };
      setColumnsVisible(columnVisible);
  }

  function setMask(item,value){
    const columnVisible = {...columnsVisible};
    columnVisible[item] = value;
    for(const val in columnVisible) {
      if(columnVisible[val]==false){
        ref.current.hideColumn(`${val}`);
      }
      else{
        ref.current.showColumn(`${val}`);
      }
    }
    setColumnsVisible(columnVisible);
  }
  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: SUMMARY_EMAIL_TRAINING_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);


    return(
      <>
      <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewSummaryEmail()}><AddIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editSummaryEmail()}><EditIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copySummaryEmail()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="search"><button onClick={searchIconColor!="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue("");ref.current.clearFilter();}}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="export"><button onClick={() => ref.current.download("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => { userInteractedRef.current = true; captureHScroll(); refreshFromStart(); }} title={t('Common.Refresh')}><RefreshIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="tofirst"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="toup"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="todown"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="tolast"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button onClick={() => openFavoriteDialog("Emaily","SummaryEmailTrainingList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="fast"><button onClick={() => setFastView("SummaryEmailTrainingList",null,columns)}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
        </div>
        </IntersectionObserverWrapper>
      </div>
<div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      data={undefined}
      className='h-[calc(100vh_-_193px)]'
      onRef={(r) => (ref.current = r?.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          tableBuiltRef.current = true;
          const table = ref.current;
          const mask = state.user_mask_filters.filter(m => m.page === "SummaryEmailTrainingList");
          const safeParse = (v, fallback) => { if (v == null) return fallback; if (typeof v === "string") { try { return JSON.parse(v); } catch { return fallback; } } return v; };
          isRestoringRef.current = true;
          if (mask.length > 0 && table) {
            const attributes = safeParse(mask[0].attributes, []);
            const filters = safeParse(mask[0].filters, []);
            const sorters = safeParse(mask[0].sorters, []);
            const json_columns = safeParse(mask[0].columns, {});
            if (Array.isArray(attributes) && attributes.length > 1) table.setColumnLayout(attributes);
            if (Array.isArray(filters)) filters.forEach(f => table.setHeaderFilterValue(f.field, f.value));
            if (Array.isArray(sorters) && sorters.length > 0) table.setSort(sorters);
            if (json_columns && typeof json_columns === "object") {
              setColumnsVisible(json_columns);
              for (const column in json_columns) { if (json_columns[column] === false) table.hideColumn(column); else table.showColumn(column); }
            }
            refreshFromStart();
          }
          isRestoringRef.current = false;
        },
        headerFilterChanged: () => { if (!isRestoringRef.current) userInteractedRef.current = true; refreshFromStart(); },
        sortChanged: () => { if (!isRestoringRef.current) userInteractedRef.current = true; },
        dataSorted: () => { if (!isRestoringRef.current) userInteractedRef.current = true; },
        columnMoved: () => setUserMaskFilter("SummaryEmailTrainingList", "column_move", null, null, ref.current?.getColumnLayout?.()),
        columnResized: () => setUserMaskFilter("SummaryEmailTrainingList", "column_resized", null, null, ref.current?.getColumnLayout?.()),
        renderComplete: () => restoreHScroll(),
      }}
      options={{
        layout:"fitColumns", renderHorizontal:"virtual", rowHeight:42, movableColumns: true, resizableColumnFit: true,
        printAsHtml:true,
        printHeader: () => buildCanonicalPrintHeaderHtml({
          branding: state?.branding,
          productFallbackSrc: defaultProductLogoSrc,
          companySettingsPrint: state?.company_settings_print,
          moduleSettings: state?.module_settings,
          title: t('Print.Title.SummaryEmailTraining'),
          printDateLabel: t('Print.DateLabel'),
        }),
        printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
        printRowRange:"active",
        ajaxURL: '/api/summary_emails/paged', ajaxParams: () => ({}),
        ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
        ajaxRequesting: () => {
          if (tableBuiltRef.current && !isRestoringRef.current) captureHScroll();
          const table = getTable();
          if (table?.initialized) table.alert?.(t('Common.LoadingEllipsis'));
          return true;
        },
        ajaxResponse: (_url, _params, response) => {
          getTable()?.clearAlert?.();
          return response;
        },
        ajaxError: () => { getTable()?.clearAlert?.(); },
        dataLoader: true, dataLoaderLoading: t('Common.LoadingData'), dataLoaderError: t('Common.LoadFailed'),
        placeholder: t('Common.NoData'),
        progressiveLoad: 'scroll', progressiveLoadScrollMargin: 80, paginationSize: pageSizePc,
        filterMode: 'remote', sortMode: 'remote', pagination: false, initialSort: [{ column: 'id', dir: 'desc' }],
      }}/> 
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })}
                 <button onClick={() => {setUserMaskFilter("SummaryEmailTrainingList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
      
      </div> 
 </>
    )

}